export default __webpack_public_path__ + "static/media/analisis_de_datos_prueba-sangre.437d463c.png";